import { cva } from 'class-variance-authority';

export const blockButtonVariants = cva(
  'inline-flex items-center justify-center gap-2 whitespace-nowrap rounded transition-colors text-sm font-medium focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none w-[150px] h-[60px]',
  {
    variants: {
      variant: {
        primary: 'bg-block-button-primary text-primary hover:bg-block-button-primary-hover disabled:opacity-40',
        secondary:
          'bg-block-button-secondary text-foreground hover:bg-block-button-secondary-hover disabled:opacity-40',
      },
      size: {
        default: 'h-10 px-4 py-2',
        block: 'w-[150px] h-[60px]',
      },
    },
    defaultVariants: {
      variant: 'primary',
      size: 'block',
    },
  },
);
